import { render, staticRenderFns } from "./DetailHasilUjianType.vue?vue&type=template&id=6126054e&scoped=true"
import script from "./DetailHasilUjianType.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126054e",
  null
  
)

export default component.exports